<template>
  <v-btn
    v-if="canLaunchAssist"
    :variant="variant"
    :color="color"
    :size="size"
    :loading="launchLoading"
    :disabled="disabled || !entityId || !entityType || !profileKey"
    @click="launchAssist"
  >
    <v-icon start>{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
import axios from "axios";
import { buildAiWorkspaceTarget, hasAiWorkspaceAccess } from "@/Utile/aiAssist.mjs";

export default {
  name: "AiAssistLaunchButton",
  emits: ["error"],
  props: {
    entityType: {
      type: String,
      required: true,
    },
    entityId: {
      type: [String, Number],
      required: true,
    },
    profileKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "AI Assist",
    },
    icon: {
      type: String,
      default: "mdi-robot-outline",
    },
    color: {
      type: String,
      default: "primary",
    },
    variant: {
      type: String,
      default: "tonal",
    },
    size: {
      type: String,
      default: "small",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      launchLoading: false,
    };
  },
  computed: {
    canLaunchAssist() {
      return hasAiWorkspaceAccess();
    },
  },
  methods: {
    async launchAssist() {
      if (this.launchLoading || this.disabled) {
        return;
      }

      this.launchLoading = true;
      try {
        const entityType = encodeURIComponent(String(this.entityType || "").trim());
        const entityId = encodeURIComponent(String(this.entityId || "").trim());
        const profileKey = encodeURIComponent(String(this.profileKey || "").trim());
        const { data } = await axios.post(`/ai/assist/${entityType}/${entityId}/${profileKey}`);
        const target = buildAiWorkspaceTarget(data);
        await this.$router.push(target).catch(() => {});
      } catch (error) {
        this.$emit("error", error?.response?.data?.message || "Nu s-a putut lansa AI assist.");
      } finally {
        this.launchLoading = false;
      }
    },
  },
};
</script>
